// extracted by mini-css-extract-plugin
export default {"wrap":"uC-z","fullWidth":"vC-z","searchPlacement":"wC-z","items":"xC-z","featureCss":"yC-z","disabled":"zC-z","imgCss":"AC-z"};